import { createSlice } from "@reduxjs/toolkit";

const staffSlice = createSlice({
  name: "staff",
  initialState: {
    staffMembers: {
      data: [],
      loading: false,
      error: null,
    },
    designations: {
      data: [],
      loading: false,
      error: null,
    },
  },
  reducers: {
    // Fetch staff members actions
    fetchStaffStart(state) {
      state.staffMembers.loading = true;
      state.staffMembers.error = null;
    },
    fetchStaffSuccess(state, action) {
      state.staffMembers.loading = false;
      state.staffMembers.data = action.payload;
    },
    fetchStaffFailure(state, action) {
      state.staffMembers.loading = false;
      state.staffMembers.error = action.payload;
    },

    // Add staff member actions
    addStaffStart(state) {
      state.staffMembers.loading = true;
      state.staffMembers.error = null;
    },
    addStaffSuccess(state, action) {
      state.staffMembers.loading = false;
      state.staffMembers.data = [...state.staffMembers.data, action.payload];
    },
    addStaffFailure(state, action) {
      state.staffMembers.loading = false;
      state.staffMembers.error = action.payload;
    },

    // Update staff member actions
    updateStaffStart(state) {
      state.staffMembers.loading = true;
      state.staffMembers.error = null;
    },
    updateStaffSuccess(state, action) {
      state.staffMembers.loading = false;
      const index = state.staffMembers.data.findIndex(
        (staff) => staff.id === action.payload.id
      );
      if (index !== -1) {
        state.staffMembers.data[index] = action.payload;
      }
    },
    updateStaffFailure(state, action) {
      state.staffMembers.loading = false;
      state.staffMembers.error = action.payload;
    },

    // Delete staff member actions
    deleteStaffStart(state) {
      state.staffMembers.loading = true;
      state.staffMembers.error = null;
    },
    deleteStaffSuccess(state, action) {
      state.staffMembers.loading = false;
      state.staffMembers.data = state.staffMembers.data.filter(
        (staff) => staff.id !== action.payload
      );
    },
    deleteStaffFailure(state, action) {
      state.staffMembers.loading = false;
      state.staffMembers.error = action.payload;
    },
    fetchDesignationsStart(state) {
        state.designations.loading = true;
        state.designations.error = null;
      },
      fetchDesignationsSuccess(state, action) {
        state.designations.loading = false;
        state.designations.data = action.payload;
      },
      fetchDesignationsFailure(state, action) {
        state.designations.loading = false;
        state.designations.error = action.payload;
      },
  },
});

export const {
  fetchStaffStart,
  fetchStaffSuccess,
  fetchStaffFailure,
  addStaffStart,
  addStaffSuccess,
  addStaffFailure,
  updateStaffStart,
  updateStaffSuccess,
  updateStaffFailure,
  deleteStaffStart,
  deleteStaffSuccess,
  deleteStaffFailure,
  fetchDesignationsStart,
  fetchDesignationsSuccess,
  fetchDesignationsFailure
} = staffSlice.actions;

export default staffSlice.reducer;
